<!-- =========================================================================================
    File Name: GoogleMapBasic.vue
    Description: Google map Basic
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
        <GmapMap
                :center="reCenter"
                :zoom="7"
                map-type-id="terrain"
                style="width: 100%; height: 415px">
            <GmapMarker
                    :key="index"
                    v-for="(m, index) in mapMarkers"
                    :position="m"
                    icon="/images/custom-icons/map-marker.png"
                    :clickable="true"
                    :draggable="true"
                    @click="reCenter=m"
            />
        </GmapMap>
    </div>
</template>

<script>
    export default {
        props: {
            markers: {
                type: [Array, Object],
                required: true
            },

            center: {
                type: Object
            }
        },

        data() {
            return {
                reCenter: {},
                mapMarkers: []
            }
        },

        created() {
            if (Array.isArray(this.markers)) this.mapMarkers = [ ...this.markers ];
            else this.mapMarkers = [ {...this.markers} ];

            if (this.center === null || this.center === undefined || Object.keys(this.center).length === 0) {
                this.reCenter = { ...this.mapMarkers[0] };
            }else {
                this.reCenter = { ...this.center };
            }
        }
    }
</script>